/**
 * LEGACY MOCK DATA - FOR REFERENCE ONLY
 * 
 * IMPORTANT: This file contains static mock data used during initial development.
 * 
 * For production deployments:
 * - All CMS content is stored in MongoDB and managed via Admin Panel
 * - Database is the SINGLE SOURCE OF TRUTH for all content
 * - Mock data in this file may be used as UI placeholders for empty fields
 * - DO NOT rely on this file for actual content - use Admin Panel to manage content
 * - Data persists across server restarts, rebuilds, and redeployments
 * 
 * This file is kept for:
 * - Reference/documentation of data structures
 * - UI placeholder fallbacks when database fields are empty
 * - Backward compatibility during migration
 */

// Mock data for G.A Technology & Power City

export const companyInfo = {
  name: "G.A Technology & Power City",
  tagline: "Rising with Innovation & Reliability",
  founded: "2010",
  employees: "150+",
  projectsCompleted: "500+",
  description: "Leading engineering solutions provider in Bangladesh, specializing in elevators, escalators, generators, HVAC systems, solar solutions, and street lighting with over a decade of excellence.",
  mission: "To provide innovative, reliable, and safe engineering solutions that enhance infrastructure development across Bangladesh.",
  vision: "To be the most trusted name in engineering solutions, contributing to Bangladesh's growth through cutting-edge technology and exceptional service.",
  values: ["Safety First", "Innovation", "Quality Excellence", "Customer Focus", "Reliability"]
};

export const contactInfo = {
  addresses: [
    {
      city: "Dhaka",
      address: "House 45, Road 12, Block C, Bashundhara R/A, Dhaka-1229, Bangladesh",
      phone: "+880-2-55012345",
      email: "dhaka@gatechnologypower.com"
    },
    {
      city: "Chittagong", 
      address: "Suite 302, Green Tower, Agrabad Commercial Area, Chittagong-4100, Bangladesh",
      phone: "+880-31-726789",
      email: "chittagong@gatechnologypower.com"
    }
  ],
  generalEmail: "info@gatechnologypower.com",
  whatsapp: "+880-1712-345678",
  website: "www.gatechnologypower.com"
};

export const products = [
  {
    id: "lift",
    name: "Lift",
    icon: "Building",
    description: "Complete lift solutions including local and imported brands with advanced safety features.",
    categories: {
      local: {
        name: "Local Lifts (Gatechnology BD)",
        types: ["Passenger Lift", "Capsule Lift", "Hospital Lift", "Cargo Lift", "Escalator"]
      },
      imported: {
        name: "Imported Lifts (by Brand)",
        brands: ["Mitsubishi Lift", "Fuji Lift", "Sigma Lift", "Otis Lift", "Kone Lift", "Schindler Lift", "ThyssenKrupp Lift"]
      }
    },
    types: ["Passenger Lift", "Capsule Lift", "Hospital Lift", "Cargo Lift"],
    features: ["Advanced Safety Systems", "Energy Efficient", "Smooth Operation", "Modern Design"],
    image: "https://images.unsplash.com/photo-1673006456789-ab4ab22edd88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBlbGV2YXRvcnxlbnwwfHx8fDE3NTg4NjkxMjB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "generators",
    name: "Generators",
    icon: "Zap",
    description: "Reliable diesel and gas generators for industrial and commercial power backup solutions.",
    types: ["Industrial Generators", "Commercial Generators", "Residential Generators"],
    features: ["Automatic Start", "Fuel Efficient", "Low Noise", "Weather Protection"],
    image: "https://images.unsplash.com/photo-1636867900334-025210ac78a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZ2VuZXJhdG9yfGVufDB8fHx8MTc1ODg4MjY4Nnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "hvac",
    name: "HVAC Systems",
    icon: "Wind",
    description: "Complete heating, ventilation, and air conditioning solutions for all building types.",
    types: ["Central AC Systems", "VRF Systems", "Chiller Systems", "Ventilation Systems"],
    features: ["Energy Efficient", "Smart Controls", "Quiet Operation", "Professional Installation"],
    image: "https://images.unsplash.com/photo-1708449287110-2f2418fb5a62"
  },
  {
    id: "solar",
    name: "Solar Solutions",
    icon: "Sun",
    description: "Sustainable solar power systems and street lighting solutions for modern infrastructure.",
    types: ["Rooftop Solar", "Solar Street Lights", "Solar Water Heating", "Grid-tie Systems"],
    features: ["Clean Energy", "Cost Effective", "Long Lifespan", "Government Approved"],
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d"
  },
  {
    id: "spare-parts",
    name: "Spare Parts",
    icon: "Settings",
    description: "Genuine spare parts and components for all our installed systems with quick delivery.",
    types: ["Elevator Parts", "Escalator Parts", "Generator Parts", "HVAC Components"],
    features: ["Genuine Parts", "Quick Delivery", "Warranty Coverage", "Technical Support"],
    image: "https://images.unsplash.com/photo-1636867759143-c28c1e909bd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZ2VuZXJhdG9yfGVufDB8fHx8MTc1ODg4MjY4Nnww&ixlib=rb-4.1.0&q=85"
  }
];

export const projects = [
  {
    id: 1,
    title: "Bashundhara City Shopping Complex",
    category: "Elevators & Escalators",
    location: "Dhaka",
    year: "2023",
    description: "Installation of 12 high-speed elevators and 8 escalators in Bangladesh's largest shopping mall.",
    image: "https://images.unsplash.com/photo-1520121843168-25f75bb5c99a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxlc2NhbGF0b3J8ZW58MHx8fHwxNzU4ODgyNjc5fDA&ixlib=rb-4.1.0&q=85",
    client: "Bashundhara Group"
  },
  {
    id: 2,
    title: "Dhaka Medical College Hospital",
    category: "Hospital Elevators",
    location: "Dhaka",
    year: "2022",
    description: "Specialized hospital elevators with stretcher accommodation and emergency backup systems.",
    image: "https://images.unsplash.com/photo-1673006456789-ab4ab22edd88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBlbGV2YXRvcnxlbnwwfHx8fDE3NTg4NjkxMjB8MA&ixlib=rb-4.1.0&q=85",
    client: "Government of Bangladesh"
  },
  {
    id: 3,
    title: "Chittagong Port Authority",
    category: "Industrial Generators",
    location: "Chittagong",
    year: "2023",
    description: "2MW backup power solution for critical port operations with redundant systems.",
    image: "https://images.pexels.com/photos/9800092/pexels-photo-9800092.jpeg",
    client: "Chittagong Port Authority"
  },
  {
    id: 4,
    title: "Gulshan Corporate Tower",
    category: "HVAC Systems",
    location: "Dhaka",
    year: "2022",
    description: "Complete central air conditioning system for 25-story commercial building.",
    image: "https://images.unsplash.com/photo-1757219525975-03b5984bc6e8",
    client: "Square Group"
  },
  {
    id: 5,
    title: "Solar Street Light Project",
    category: "Solar Solutions",
    location: "Multiple Districts",
    year: "2023",
    description: "Installation of 500+ solar street lights across rural areas of Bangladesh.",
    image: "https://images.unsplash.com/photo-1641927854144-3c2c11371272",
    client: "Rural Development Board"
  },
  {
    id: 6,
    title: "Green Factory Solar Installation",
    category: "Solar Power",
    location: "Gazipur",
    year: "2023",
    description: "500kW rooftop solar system for textile manufacturing facility.",
    image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9",
    client: "Beximco Textiles"
  }
];

export const mediaGallery = {
  images: [
    {
      id: 1,
      title: "Modern Escalator Installation",
      category: "escalators",
      url: "https://images.unsplash.com/photo-1567449303078-57ad995bd17a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxlc2NhbGF0b3J8ZW58MHx8fHwxNzU4ODgyNjc5fDA&ixlib=rb-4.1.0&q=85",
      description: "Professional escalator installation in commercial complex"
    },
    {
      id: 2,
      title: "Generator Facility",
      category: "generators",
      url: "https://images.unsplash.com/photo-1636867759143-c28c1e909bd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZ2VuZXJhdG9yfGVufDB8fHx8MTc1ODg4MjY4Nnww&ixlib=rb-4.1.0&q=85",
      description: "Industrial generator installation and maintenance"
    },
    {
      id: 3,
      title: "Solar Power Project",
      category: "solar",
      url: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d",
      description: "Large-scale solar installation project"
    },
    {
      id: 4,
      title: "Street Lighting Infrastructure",
      category: "lighting",
      url: "https://images.unsplash.com/photo-1650658357305-d796f94ccfba",
      description: "Modern street lighting project implementation"
    },
    {
      id: 5,
      title: "HVAC System Installation",
      category: "hvac",
      url: "https://images.unsplash.com/photo-1708449287110-2f2418fb5a62",
      description: "Commercial HVAC system installation"
    },
    {
      id: 6,
      title: "Escalator Project",
      category: "escalators",
      url: "https://images.pexels.com/photos/417014/pexels-photo-417014.jpeg",
      description: "Escalator installation in shopping complex"
    }
  ],
  videos: [
    {
      id: 1,
      title: "Elevator Testing Process",
      thumbnail: "https://images.unsplash.com/photo-1673006456789-ab4ab22edd88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBlbGV2YXRvcnxlbnwwfHx8fDE3NTg4NjkxMjB8MA&ixlib=rb-4.1.0&q=85",
      description: "Quality testing of elevator installation"
    },
    {
      id: 2,
      title: "Solar Installation Time-lapse",
      thumbnail: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9",
      description: "Complete solar panel installation process"
    }
  ]
};

export const certificates = [
  {
    id: 1,
    name: "ISO 9001:2015 Quality Management",
    issuer: "Bureau Veritas",
    year: "2023",
    description: "International quality management system certification"
  },
  {
    id: 2,
    name: "ISO 14001:2015 Environmental Management",
    issuer: "SGS Bangladesh",
    year: "2023",
    description: "Environmental management system certification"
  },
  {
    id: 3,
    name: "RAJUK Approved Contractor",
    issuer: "RAJUK, Dhaka",
    year: "2022",
    description: "Approved contractor for construction and installation works"
  },
  {
    id: 4,
    name: "Electrical Installation License",
    issuer: "Department of Electrical Safety",
    year: "2023",
    description: "Licensed for electrical installation and maintenance"
  }
];

export const whyChooseUs = [
  {
    icon: "Shield",
    title: "Safety First",
    description: "Adherence to international safety standards with comprehensive testing protocols"
  },
  {
    icon: "Award",
    title: "Proven Experience",
    description: "Over 13 years of excellence with 500+ successful projects across Bangladesh"
  },
  {
    icon: "Headphones",
    title: "24/7 Support",
    description: "Round-the-clock customer support and emergency maintenance services"
  },
  {
    icon: "Lightbulb",
    title: "Innovation",
    description: "Latest technology integration with smart controls and energy-efficient solutions"
  },
  {
    icon: "CheckCircle",
    title: "Quality Assurance",
    description: "ISO certified quality management with genuine parts and professional installation"
  },
  {
    icon: "Users",
    title: "Expert Team",
    description: "Certified engineers and technicians with extensive training and experience"
  }
];

export const clientLogos = [
  { name: "Bashundhara Group", logo: "/api/placeholder/120/60" },
  { name: "Square Group", logo: "/api/placeholder/120/60" },
  { name: "BRTC", logo: "/api/placeholder/120/60" },
  { name: "Chittagong Port Authority", logo: "/api/placeholder/120/60" },
  { name: "Beximco", logo: "/api/placeholder/120/60" },
  { name: "Grameen Bank", logo: "/api/placeholder/120/60" }
];

// Mock quote request submission
export const submitQuoteRequest = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Quote request submitted:', formData);
      resolve({ success: true, message: 'Quote request submitted successfully!' });
    }, 1000);
  });
};

// Mock contact form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};